import PropTypes from 'prop-types';
import React from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import {
  changeLocale,
  clearLoginError,
  doLogin,
  goToForgetPassword,
  getAppVersion,
} from '../../redux/actions/user.actions';
import { selectableLanguages } from '../../lang/config';
import { appConfig, navigationURLs, registration } from '../../config/config';
import RegistrationHeader from '../registration/registrationHeader/RegistrationHeader';
import RegistrationFooter from '../registration/registrationFooter/RegistrationFooter';
import ErrorModal from '../Modal/GenericDialogs/ErrorModal';
import InputEmail from '../Input/InputEmail/InputEmail';
import { refreshCacheAndReload, setPageTitle } from '../Utils/pageUtils';

import '../investor/KycModal/loader.scss';
import './Login.scss';

import Auth0Helper from '../Utils/Auth0Helper';
import PrComponent from '../App/PrComponent';

const messages = defineMessages({
  placeholderEmail: {
    id: 'login.labels.placeholder.email',
    defaultMessage: 'Email address',
  },
  placeholderPassword: {
    id: 'login.labels.placeholder.password',
    defaultMessage: 'Password',
  },
});

class Login extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      email: '',
      password: '',
      isEmailValid: false,
      shouldShowEmailNotValid: false,
    };
  }

  componentWillMount() {
    setPageTitle('webapp.page.title.login');
  }

  componentDidMount() {
    this.props.getAppVersion();
  }
  handlePasswordChange(e) {
    const state = this.state;
    state.password = e.target.value.slice(0, registration.passwordLengthMax);
    this.setState(state);
  }

  onEmailChange(value) {
    const state = this.state;
    state.email = value;
    this.setState(state);
  }

  isValidEmail(isValid) {
    const state = this.state;
    state.shouldShowEmailNotValid = !isValid;
    state.isEmailValid = isValid;
    this.setState(state);
  }

  onFocusEmail() {
    const state = this.state;
    state.shouldShowEmailNotValid = false;
    this.setState(state);
  }

  login(event) {
    event.preventDefault();

    if (appConfig.isNewPlatform) {
      Auth0Helper.login({
        userName: this.state.email,
        password: this.state.password,
      });
    } else {
      if (this.state.isEmailValid) {
        this.props.doLogin({
          email: this.state.email,
          password: this.state.password,
        });
      }
    }
  }

  onChangeLanguage(language) {
    this.props.onChangeLocale(language.id);
  }

  goToForgetPassword(event) {
    // TODO: add logic
    event.preventDefault();
    this.props.onGoToForgotPassword();
  }

  onGoToCreditplaceCom() {
    window.location = navigationURLs.creditPlaceHome;
  }

  renderLoginError() {
    const { loginError } = this.props;
    switch (loginError) {
      case 'INVALID_CREDENTIALS':
        return (
          <div className='with-errors'>
            <ul className='error-message'>
              <li>
                <FormattedMessage
                  id={'login.labels.error.credentials'}
                  defaultMessage={
                    'This email address doesn’t match any account. Double check and try again.'
                  }
                />
              </li>
            </ul>
          </div>
        );
      case 'UNAUTHORIZED_USER':
        return (
          <div className='with-errors'>
            <ul className='error-message'>
              <li>
                <FormattedMessage
                  id={'login.labels.error.unauthorizedUser'}
                  defaultMessage={
                    'This email address doesn’t match any account. Double check and try again.'
                  }
                />
              </li>
            </ul>
          </div>
        );
      default:
        return '';
    }
  }

  getEmailErrorMessage(notValid) {
    let emailValidationErrorMessage = <div />;
    if (notValid) {
      emailValidationErrorMessage = (
        <div className='with-errors'>
          <ul className='error-message'>
            <li>
              <FormattedMessage
                id={'registration.createNewAccount.validation.email'}
                defaultMessage={'That’s not a valid email address'}
              />
            </li>
          </ul>
        </div>
      );
    }
    return emailValidationErrorMessage;
  }

  getPlaceHolder(id, defaultMessage) {
    const intl = this.props.intl;
    return intl.formatMessage({
      id: id,
      defaultMessage: defaultMessage,
    });
  }

  renderMarkup() {
    const { locale } = this.props;
    const languageSelection =
      this.props.selectableLanguages || selectableLanguages;
    const language = languageSelection.find((item) => locale === item.id);
    const createNewAccountLink = (
      <FormattedMessage
        id={'login.links.createAnAccount'}
        defaultMessage={'{createAnAccount}'}
        values={{
          createAnAccount: (
            <Link className='registerLink' to='/register'>
              <FormattedMessage
                id={'login.action.createAnAccount'}
                defaultMessage={'Sign Up'}
              />
            </Link>
          ),
        }}
      />
    );

    const loginButton = this.props.isLoading ? (
      <div className='loader-wrapper'>
        <div className='loader' />
      </div>
    ) : (
      <button type='submit' className='btn submit-button login--submit'>
        <FormattedMessage id={'login.labels.login'} defaultMessage={'Log in'} />
      </button>
    );

    const placeholderEmail = this.getPlaceHolder(
      messages.placeholderEmail.id,
      messages.placeholderEmail.defaultMessage
    );
    const placeholderPassword = this.getPlaceHolder(
      messages.placeholderPassword.id,
      messages.placeholderPassword.defaultMessage
    );

    return (
      <div className='login--container'>
        <RegistrationHeader
          languageSelection={languageSelection}
          selectedLanguage={language}
          onChangeLanguage={this.onChangeLanguage}
          navigateOnClickLogoImage={this.onGoToCreditplaceCom}
        />
        <header className='login__header'>
          <FormattedMessage
            id={'login.labels.header.login'}
            defaultMessage={'Log In'}
          />
        </header>
        <div className='login-content clearfix'>
          <form onSubmit={this.login}>
            <div className='formContent'>
              <div className='row'>
                <div className='subHeader col-xs-24 col-sm-20 col-md-20 col-lg-16 pad-bottom col-lg-offset-4 col-md-offset-2 col-sm-offset-2 col-xs-offset-0'>
                  <FormattedMessage
                    id={'login.labels.subHeader.newToCP'}
                    defaultMessage={'New to Creditplace?'}
                  />
                  <span className='login-goToCreateNewAccount'>
                    {createNewAccountLink}
                  </span>
                </div>
              </div>
              <div className='row'>
                <div className='col-xs-24 col-sm-20 col-md-20 col-lg-16 pad-bottom col-lg-offset-4 col-md-offset-2 col-sm-offset-2 col-xs-offset-0'>
                  <div className='required hidden-xs'>
                    <label className='inputLabel'>
                      <FormattedMessage
                        id={'login.labels.email'}
                        defaultMessage={'Email'}
                      />
                    </label>
                  </div>
                  <InputEmail
                    onChange={this.onEmailChange}
                    externalClass='col-xs-22 col-sm-18 col-md-18 col-lg-14 inputPassword form-control'
                    email={this.state.email}
                    validate={this.isValidEmail}
                    placeholder={placeholderEmail}
                    focus={this.onFocusEmail}
                    isAutoFocus
                    id='inputEmail'
                  />
                  {this.getEmailErrorMessage(
                    this.state.shouldShowEmailNotValid
                  )}
                </div>
              </div>
              <div className='row pad-bottom'>
                <div className='col-xs-24 col-sm-20 col-md-20 col-lg-16 col-lg-offset-4 col-md-offset-2 col-sm-offset-2 col-xs-offset-0'>
                  <div className='login--label required hidden-xs'>
                    <label className='inputLabel'>
                      <FormattedMessage
                        id={'login.labels.password'}
                        defaultMessage={'Password'}
                      />
                    </label>
                  </div>
                  <input
                    value={this.state.password}
                    onChange={this.handlePasswordChange}
                    type='password'
                    id='inputPassword'
                    className='col-xs-22 col-sm-18 col-md-18 col-lg-14 inputPassword form-control'
                    placeholder={placeholderPassword}
                  />
                  {this.renderLoginError()}
                  <div className='login-forgotpassword'>
                    <FormattedMessage
                      id={'login.links.forgotPassword'}
                      defaultMessage={'{forgotPassword}'}
                      values={{
                        forgotPassword: (
                          <a onClick={this.goToForgetPassword} href=''>
                            <FormattedMessage
                              id={'login.action.forgotPassword'}
                              defaultMessage={'Forgot password?'}
                            />
                          </a>
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-xs-24 col-sm-20 col-md-20 col-lg-16 col-lg-offset-4 col-md-offset-2 col-sm-offset-2 col-xs-offset-0'>
                  {loginButton}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className='footerContainer'>
          <RegistrationFooter
            languageSelection={languageSelection}
            selectedLanguage={language}
            onChangeLanguage={this.onChangeLanguage}
          />
        </div>
      </div>
    );
  }

  onCloseModal() {
    this.props.onClearLoginError();
  }

  renderErrorModal() {
    const { loginError } = this.props;
    const isShowModal = loginError === 'Error';
    return (
      <div className=''>
        <ErrorModal show={isShowModal} onPrimaryClick={this.onCloseModal} />
      </div>
    );
  }

  render() {
    const { investorList, investorDashboard } = navigationURLs;

    const isSeedInvestor = _.get(
      this.props,
      'user.currentFinancialEntity.isSeedInvestor'
    );
    const isInvestor =
      _.get(this.props, 'user.currentFinancialEntity.isInvestor') &&
      !isSeedInvestor;

    if (
      window.appVersion &&
      this.props.appVersion &&
      window.appVersion != this.props.appVersion
    ) {
      return refreshCacheAndReload();
    }

    if (isInvestor) return <Redirect to={investorList} push />;
    else if (isSeedInvestor) return <Redirect to={investorDashboard} push />;

    return (
      <div className='loginPage-container'>
        <div className='loginPage-container--background bodyHeight custom-hidden-xs'>
          {/*{window.appVersion} : {this.props.appVersion} - should refresh : {window.appVersion != this.props.appVersion}*/}
          <div className='image-container'>
            {/* <img src={logo} alt="" /> */}
          </div>
        </div>
        <div className='row clearPadding-right bodyHeight'>
          <div className='bodyHeight component-container'>
            {this.renderMarkup()}
          </div>
        </div>
        {this.renderErrorModal()}
        <PrComponent />
      </div>
    );
  }
}

Login.propTypes = {
  token: PropTypes.string,
  doLogin: PropTypes.func.isRequired,
  user: PropTypes.object,
  onChangeLocale: PropTypes.func,
  locale: PropTypes.string,
  selectableLanguages: PropTypes.array,
  isLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    appVersion: state.auth.get('appVersion'),
    user:
      state.auth && state.auth.get('user')
        ? state.auth.get('user').toJS()
        : null,
    locale: state.auth.get('locale'),
    loginError: state.auth ? state.auth.get('loginError') : null,
    isLoading: state.auth ? state.auth.get('isLoading') : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAppVersion: () => dispatch(getAppVersion()),
    doLogin: (creds) => dispatch(doLogin(creds)),
    onChangeLocale: (locale) => dispatch(changeLocale(locale)),
    onGoToForgotPassword: () => dispatch(goToForgetPassword()),
    onClearLoginError: () => dispatch(clearLoginError()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Login));
